module.exports = __webpack_public_path__ + "static/media/close_icon.12ee24d4.svg";